import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './UpperBarIn.css';
import frenchFlag from '../../../images/fr.png';
import englishFlag from '../../../images/en.png';
import arabicFlag from '../../../images/ar.png';
import { logout } from '../../../redux/actions/authActions';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import {API_BASE_URL} from "../../../../api";

const getUserInitials = (user) => {
    const fullNameParts = (user?.fullName || "").trim().split(/\s+/).filter(Boolean);
    const firstName = user?.firstName || user?.prenom || fullNameParts[0] || "";
    const lastName = user?.lastName || user?.nom || (fullNameParts.length > 1 ? fullNameParts[fullNameParts.length - 1] : "") || "";
    return `${lastName.charAt(0)}${firstName.charAt(0)}`.toUpperCase() || "U";
};

const UpperBarIn = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
    const userDropdownRef = useRef(null);

    const currentUser = useSelector(state => state.auth?.user);
    const [profileImageFailed, setProfileImageFailed] = useState(false);
    const profilePhotoSrc = currentUser && currentUser.profilePictureUrl
        ? `${API_BASE_URL}/api/users/images/profile/${currentUser.profilePictureUrl}`
        : "";
    const hasProfilePhoto = !!profilePhotoSrc && !profileImageFailed;
    const userInitials = getUserInitials(currentUser);

    useEffect(() => {
        const isRTL = i18n.language === 'ar';
        document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
        document.documentElement.setAttribute('lang', i18n.language);
    }, [i18n.language]);

    useEffect(() => {
        setProfileImageFailed(false);
    }, [currentUser?.profilePictureUrl]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
                setIsUserDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const handleLogout = () => {
        dispatch(logout());
        setIsUserDropdownOpen(false);
        navigate('/');
    };

    const handleProfileClick = () => {
        setIsUserDropdownOpen(false);
        navigate('/cards');
    };

    return (
        <div className="upper-bar-in">
            <div className="upper-bar-content">

                <div className="right-section">
                    {/* Language Selector */}
                    <div className="language-flags">
                        <button
                            onClick={() => changeLanguage('fr')}
                            className={`flag-button ${i18n.language === 'fr' ? 'active' : ''}`}
                            title="Français"
                        >
                            <img src={frenchFlag} alt="Français" className="flag-image"/>
                        </button>
                        <button
                            onClick={() => changeLanguage('en')}
                            className={`flag-button ${i18n.language === 'en' ? 'active' : ''}`}
                            title="English"
                        >
                            <img src={englishFlag} alt="English" className="flag-image"/>
                        </button>
                        <button
                            onClick={() => changeLanguage('ar')}
                            className={`flag-button ${i18n.language === 'ar' ? 'active' : ''}`}
                            title="العربية"
                        >
                            <img src={arabicFlag} alt="العربية" className="flag-image"/>
                        </button>
                    </div>

                    {/* User Profile Dropdown */}
                    <div className="dropdown-container-roles" ref={userDropdownRef}>
                        <div
                            className="user-profile"
                            onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
                        >
                            <div className="user-avatar">

                                {hasProfilePhoto ? (
                                    <img
                                        src={profilePhotoSrc}
                                        alt="Profile"
                                        className="profile-image"
                                        onError={() => setProfileImageFailed(true)}
                                    />
                                ) : (
                                    <span className="user-avatar-initials">{userInitials}</span>
                                )}

                                <span className="status-indicator"></span>
                            </div>

                            <div className="user-info">
                                <span className="user-name">{currentUser?.fullName || 'Utilisateur'}</span>
                            </div>
                        </div>

                        {isUserDropdownOpen && (
                            <div className="user-dropdown">
                                <div className="user-dropdown-section">
                                    <div
                                        className="dropdown-menu-item"
                                        onClick={handleProfileClick}
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <circle cx="12" cy="7" r="4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <span>Mon profil</span>
                                    </div>

                                    <div
                                        className="dropdown-menu-item logout"
                                        onClick={handleLogout}
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <polyline points="16 17 21 12 16 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <line x1="21" y1="12" x2="9" y2="12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <span>Se déconnecter</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpperBarIn;
